import {lazy} from 'react'

const AppRoutes = [
    {
        path: '/saml-auth',
        component: lazy(() => import('../../views/ForgotPasswoord')),
        roles: ["technical delegate", "team admin", "team leader", "user", "admin"]
    },
    {
        path: '/natjecanja/odabir-igraca/:id/:competitionId',
        component: lazy(() => import('../../views/natjecanja/PrijavaTeamaNaNatjecanje/ChoosePlayers')),
        roles: ["technical delegate", "team admin", "team leader"]
    },
    {
        path: '/natjecanja/detalji/korak-1/:id',
        component: lazy(() => import('../../views/natjecanja/DetaljiNatjecanja/DetaljiNatjecanjaStep2')),
        roles: ["super admin", "admin", "technical delegate"]
    },
    {
        path: '/natjecanja/detalji/korak-3-faze/:id',
        component: lazy(() => import('../../views/natjecanja/DetaljiNatjecanja/DetaljiNatjecanjaStep3Phases')),
        roles: ["super admin", "admin", "delegate", "operative"]
    },
    {
        path: '/natjecanja/detalji/faza-natjecanja/:competitionId/:phaseName',
        component: lazy(() => import('../../views/natjecanja/DetaljiNatjecanja/CompetitionPhase')),
        roles: ["super admin", "admin", "delegate", "operative", "team admin", "team leader"]
    },
    {
        path: '/natjecanja/detalji/faza-natjecanja-grupe/:competitionId/:phaseId',
        component: lazy(() => import('../../views/natjecanja/DetaljiNatjecanja/BergerSchedule')),
        roles: ["super admin", "admin", "delegate", "operative"]
    },
    {
        path: '/natjecanja/odobri-ekipe/:id',
        component: lazy(() => import('../../views/natjecanja/ApproveTeamForCompetition/ApproveTeams')),
        roles: ["admin", "delegate", "operative"]
    },
    {
        path: '/natjecanja/odobri-igrace-ekipe/:id/:teamId',
        component: lazy(() => import('../../views/natjecanja/ApproveTeamForCompetition/ApproveTeamPlayersForCompetition')),
        roles: ["admin", "delegate", "operative"]
    },
    {
        path: '/natjecanja/odaberi-ekipu/:id',
        component: lazy(() => import('../../views/natjecanja/PrijavaTeamaNaNatjecanje/ChooseEkipa')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja/izmijeni/:id',
        component: lazy(() => import('../../views/natjecanja/EditNatjecanja')),
        roles: ["admin", "technical delegate"]
    },
    {
        path: '/natjecanja/izmijeni-detalje-natjecanja/:id',
        component: lazy(() => import('../../views/natjecanja/UrediDetaljeNatjecanja')),
        roles: ["admin", "technical delegate"]
    },
    {
        path: '/natjecanja/novi-korak-1/:id?',
        component: lazy(() => import('../../views/natjecanja/NewCompetition/newStep1')),
        roles: ["admin", "technical delegate"]
    },
    {
        path: '/natjecanja/novi-korak-2/:id?',
        component: lazy(() => import('../../views/natjecanja/NewCompetition/newStep2')),
        roles: ["admin", "technical delegate"]
    },
    {
        path: '/natjecanja/novi-korak-3/:id?',
        component: lazy(() => import('../../views/natjecanja/NewCompetition/newStep3')),
        roles: ["admin", "technical delegate"]
    },
    {
        path: '/natjecanja/:id/prijava-korak-1',
        component: lazy(() => import('../../views/natjecanja/PrijavaSastavniceNaNatjecanje/ApplicationStep1')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja/:id/prijava-korak-2',
        component: lazy(() => import('../../views/natjecanja/PrijavaSastavniceNaNatjecanje/ApplicationStep2')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja/:id/prijava-korak-3',
        component: lazy(() => import('../../views/natjecanja/PrijavaSastavniceNaNatjecanje/ApplicationStep3')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja/prijave/:id',
        component: lazy(() => import('../../views/natjecanja/Prijave')),
        roles: ["admin", "admin"]
    },
    {
        path: '/natjecanja/prijava-novog-kontakta',
        component: lazy(() => import('../../views/natjecanja')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja/pregled/:id',
        component: lazy(() => import('../../views/natjecanja')),
        roles: ["user", "admin", "team admin"]
    },
    {
        path: '/natjecanja/izmijeni/:id',
        component: lazy(() => import('../../views/natjecanja')),
        roles: ["user", "admin", "team admin"]
    },
    {
        path: '/natjecanja/pregled-akreditacije/:id',
        component: lazy(() => import('../../views/natjecanja/Akreditacije/Akreditacije')),
        roles: ["admin"]
    },
    {
        path: '/natjecanja/pregled-dokumenata/:id',
        component: lazy(() => import('../../views/natjecanja/PregledDokumenata')),
        roles: ["team admin", "team leader"]
    },
    {
        path: '/natjecanja',
        component: lazy(() => import('../../views/natjecanja')),
        roles: ["super admin", "admin", "delegate", "operative", "team admin", "team leader"]
    },
    {
        path: '/upravljanje/sastavnice/detalji-sastavnice/:id?',
        component: lazy(() => import('../../views/upravljanje/Sastavnice/NovaSastavnica')),
        roles: ["super admin", "admin", "team-lead"]
    },
    {
        path: '/upravljanje/sastavnice',
        component: lazy(() => import('../../views/upravljanje/Sastavnice/Sastavnice')),
        roles: ["super admin", "admin"]
    },
    {
        path: '/upravljanje/organizacije/detalji-organizacije/:id?',
        component: lazy(() => import('../../views/upravljanje/Organizacije/NewOrganisation')),
        roles: ["super admin"]
    },
    {
        path: '/upravljanje/organizacije',
        component: lazy(() => import('../../views/upravljanje/Organizacije/Organisations')),
        roles: ["super admin"]
    },
    {
        path: '/upravljanje/sezone',
        component: lazy(() => import('../../views/upravljanje/Seasons')),
        roles: ["super admin", "admin"]
    },
    {
        path: '/upravljanje/korisnici',
        component: lazy(() => import('../../views/upravljanje/Korisnici/Korisnici')),
        roles: ["super admin", "admin", "technician", "team admin"]
    },
    {
        path: '/upravljanje/sportovi-rekreacije/detalji/:id?',
        component: lazy(() => import('../../views/upravljanje/Sportovi/NewRecreationSport')),
        roles: ["super admin", "admin", "technician", "team admin"]
    },
    {
        path: '/upravljanje/sportovi-rekreacije',
        component: lazy(() => import('../../views/upravljanje/Sportovi/RecreationSports')),
        roles: ["super admin", "admin", "technician", "team admin"]
    },
    {
        path: '/objave/detalji-objave/:id?',
        layout: 'BlankLayout',
        component: lazy(() => import('../../views/objave/DetaljiObjave')),
        roles: ["CMS admin", "CMS editor", "CMS author"]
    },

    {
        path: '/objave',
        component: lazy(() => import('../../views/objave/Objave')),
        roles: ["super admin", "admin", "CMS admin", "CMS editor", "CMS author"]
    },

    {
        path: '/rekreacije/detalji-rekreacije-korak-1/:id?',
        component: lazy(() => import('../../views/recreations/DetaljiRekreacijeStep1')),
        roles: ["super admin", "admin", "recreations admin"]
    },
    {
        path: '/rekreacije/detalji-rekreacije-korak-2/:id?',
        component: lazy(() => import('../../views/recreations/DetaljiRekreacijeStep2')),
        roles: ["super admin", "admin", "recreations admin"]
    },

    {
        path: '/rekreacije/detalji-rekreacije-korak-3/:id?',
        component: lazy(() => import('../../views/recreations/DetaljiRekreacijeStep3')),
        roles: ["super admin", "admin", "recreations admin"]
    },

    {
        path: '/rekreacije/detalji-rekreacije-korak-4/:id?',
        component: lazy(() => import('../../views/recreations/DetaljiRekreacijeStep4')),
        roles: ["super admin", "admin", "recreations admin"]
    },
    {
        path: '/rekreacije/detalji-rekreacije-korak-5/:id?',
        component: lazy(() => import('../../views/recreations/DetaljiRekreacijeStep5')),
        roles: ["super admin", "admin", "recreations admin"]
    },
    {
        path: '/rekreacije/prijava-na-rekreaciju/:id',
        component: lazy(() => import('../../views/recreations/PrijavaRekreacije')),
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student', "recreations admin"]
    },

    {
        path: '/rekreacije/termini/lista-prisutnih/:recreationId/:dateId/:date',
        component: lazy(() => import('../../views/recreations/ListaPrisutnih')),
        roles: ["super admin", "admin", "recreations admin"]
    },

    {
        path: '/rekreacije/termini-rekreacije/:id',
        component: lazy(() => import('../../views/recreations/RekreacijeTermini')),
        roles: ["super admin", "admin", "recreations admin"]
    },
    {
        path: '/rekreacije/termini-rekreacije-student/:id',
        component: lazy(() => import('../../views/recreations/TerminiRekreacijeStudent')),
        roles: ["user"]
    },
    {
        path: '/moje-rekreacije',
        component: lazy(() => import('../../views/recreations/MojeRekreacije')),
        roles: ["student", "user"]
    },
    {
        path: '/rekreacije',
        component: lazy(() => import('../../views/recreations/Recreations')),
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student', "recreations admin"]
    },
    {
        path: '/upravljanje/roles',
        component: lazy(() => import('../../views/upravljanje/Roles/Roles')),
        roles: ["super admin", "admin", "team admin"]
    },

    {
        path: "/galerija/natjecanje/:id/:sport/utakmice",
        component: lazy(() => import("../../views/galerija/FazaUtakmice")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/galerija/utakmica/:id",
        component: lazy(() => import("../../views/galerija/GoogleDriveLink")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/galerija",
        component: lazy(() => import("../../views/galerija/index")),
        roles: ["super admin", "admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/dokumenti/kategorije",
        component: lazy(() => import("../../views/dokumenti/EditCategories")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/dokumenti/:category",
        component: lazy(() => import("../../views/dokumenti/EditDocuments")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/dokumenti",
        component: lazy(() => import("../../views/dokumenti/Dokumenti")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/Početna",
        component: lazy(() => import("../../views/stranice/pocetna/Pocetna")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/Često postavljena pitanja",
        component: lazy(() => import("../../views/stranice/pitanja/Pitanja")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/Kontakt",
        component: lazy(() => import("../../views/stranice/kontakt/Kontakt")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/O nama - Članovi/kategorije",
        component: lazy(() => import("../../views/stranice/o-nama/EditCategories")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/O nama - Članovi/new",
        component: lazy(() => import("../../views/stranice/o-nama/NewMember")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/O nama - Članovi",
        component: lazy(() => import("../../views/stranice/o-nama/ONama")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/O nama - Članice/new",
        component: lazy(() => import("../../views/stranice/o-nama-clanice/NewMember")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice/O nama - Članice",
        component: lazy(() => import("../../views/stranice/o-nama-clanice/ONama")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/stranice",
        component: lazy(() => import("../../views/stranice/index")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke/vijesti/:rowName/edit",
        component: lazy(() => import("../../views/cms-postavke/vijesti/VijestiInput")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke/vijesti/new",
        component: lazy(() => import("../../views/cms-postavke/vijesti/VijestiInput")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke/dogadanja/new",
        component: lazy(() => import("../../views/cms-postavke/dogadanja/NewEvent")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke/dogadanja/kategorije",
        component: lazy(() => import("../../views/cms-postavke/dogadanja/EditCategories")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke/dogadanja/:rowName/edit",
        component: lazy(() => import("../../views/cms-postavke/dogadanja/EditEvent")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/cms-postavke",
        component: lazy(() => import("../../views/cms-postavke/index")),
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        path: "/korisnicki-profil/:id",
        component: lazy(() => import("../../views/profil/KorisnickiProfil")),
        roles: ['super admin']
    },
    {
        path: "/korisnicki-profil",
        component: lazy(() => import("../../views/profil/KorisnickiProfil")),
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
    {
        path: "/moji-dokumenti",
        component: lazy(() => import("../../views/dokumenti/MojiDokumenti")),
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
    {
        path: "/moje-statistike",
        component: lazy(() => import("../../views/statistike/MojaNatjecanja")),
        roles: ['player', 'user', 'student']
    },
    {
        path: "/statistike-sastavnice",
        component: lazy(() => import("../../views/statistike/StatistikeSastavnice")),
        roles: ['team admin', "team leader"]
    },
    {
        path: "/terms-conditions",
        component: lazy(() => import("../../views/TermsConditions")),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
    {
        path: "/privacy-policy",
        component: lazy(() => import("../../views/PrivacyPolicy")),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
    {
        path: '/login',
        component: lazy(() => import('../../../src/views/Login')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
    },
    {
        path: '/register',
        component: lazy(() => import('../../views/Register/Register')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
    },
    {
        path: '/forgot-password',
        component: lazy(() => import('../../views/ForgotPasswoord')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
    },
    {
        path: '/reset-password',
        component: lazy(() => import('../../views/ResetPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
    },
    {
        path: '/register-details',
        component: lazy(() => import('../../../src/views/Register/RegisterDetails')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        },
    }


]

console.log("App routes length:", AppRoutes.length)

export default AppRoutes
